import { useQuery } from '@tanstack/react-query';
import { getMemberInfo } from 'shared/src/api';

export const useMemberInfo = () => {
  return useQuery({
    queryKey: ['memberInfo'],
    queryFn: getMemberInfo,
  });
};
